<canvas baseChart class="chart test-doughnut-chart"
  [data]="doughnutChartData"
  [chartType]="doughnutChartType"
  [colors]="doughnutChartColours"
  [options]="polarAreaChartOptions"
  style="pointer-events:none;">
</canvas>
<div class="test-doughnut-chart-value" [ngStyle]="{'color': valueColor}" *ngIf="title != '안구조절'">{{graphVaule + "%"}}</div>
<div class="test-doughnut-chart-value" [ngStyle]="{'color': valueColor}" *ngIf="title == '안구조절'">
  <img [src]='imgSrc' [ngClass]="graphVaule != 0 ? 'instabilityImg' : 'stabilityImg'">
</div>
